import styled from "styled-components";

export const HeroStyled = styled.main `
    & >div{
        margin: 1vw 10vw;
    }    


    a {
        font-family: 'Poppins', sans-serif;
font-size: 1.8rem;
color: #2D9CDB;
line-height: 2.5rem;

}
 h1 {
    
font-family: 'Poppins', sans-serif;
font-weight: 500;
font-size: 4.8rem;
line-height: 7.2rem;
color: #333333;
 }

img {
    width: 95vw;
border-radius: 1.8rem;
}
h2 {
    
    font-family: 'Poppins', sans-serif;
font-weight: 500;
font-size: 4.8rem;
line-height: 7.2rem;
color: #333333;
margin:2rem 0 ;
}
p {
font-family: 'Poppins', sans-serif;
color: #4F4F4F;
font-weight: 400;
font-size: 1.8rem;
line-height: 2.7rem;
width: 350px;
margin:2rem 0 ;

}
span {
    
font-family: 'Poppins', sans-serif;
font-style: normal;
font-size: 1.4rem;
line-height: 2.1rem;
}
div div {
    margin:2rem 0 ;
    
}
input {

width: 25rem;
height: 4rem;
padding:1rem;
background: #F2F2F2;
border-radius: 0.5rem;
border:none;
outline:none;
}
button {
outline:none;
border:none;
background: #2D9CDB;
padding: 0.8rem 1.8rem;
color:white;
border-radius: 0.7rem;
height:3.5rem;
/* transform: translateX(-6.3rem); */
}
`